import {
  CreateCustomVariableVariablesSchema,
  type CustomVariable,
  UpdateCustomVariableVariablesSchema,
  useCreateCustomVariable,
  useUpdateCustomVariable,
} from '~/modules/Settings/Variables/CustomVariables/api';

import CustomVariableForm, { type CustomVariableFormValues } from './CustomVariableForm';

type Props = {
  customVariable?: CustomVariable;
  onClose: () => void;
};

export default function EditCustomVariable({ customVariable, onClose }: Props) {
  const { createCustomVariable } = useCreateCustomVariable();
  const { updateCustomVariable } = useUpdateCustomVariable();

  const submitCustomVariable = (values: CustomVariableFormValues) => {
    if (customVariable?.id) {
      const updatePayload = UpdateCustomVariableVariablesSchema.parse({
        id: customVariable.id,
        data: values,
      });
      updateCustomVariable(updatePayload, { onSuccess: () => onClose() });
      return;
    }

    const createPayload = CreateCustomVariableVariablesSchema.parse(values);
    createCustomVariable(createPayload, { onSuccess: () => onClose() });
  };

  return <CustomVariableForm onSubmit={submitCustomVariable} initialValues={customVariable} />;
}
